import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export function CreateInteresMoratorioDialog({
    dialogOpen,
    setDialogOpen,
    formData,
    setFormData,
    handlecreateLatePaymentInterest
}) {
    const [open, setOpen] = useState(dialogOpen);
    const [errorField, setErrorField] = useState({});
    const [disableBtn, setDisableBtn] = useState(false);

    const cancelButtonRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleToggleDialog = () => {
        if (dialogOpen) {
            setDialogOpen(false);
        } else {
            setDialogOpen(true);
        }
        setErrorField({});
        setFormData({
            interesUsuraTea: "",
            year: "",
            month: ""
        });
    };

    const validateData = () => {
        const newErrors = {};
        let hasValidate = true;
        if (
            formData.interesUsuraTea === ""
        ) {
            newErrors.interesUsuraTea = "Debes ingresar una tasa.";
        } else if (formData.year === "") {
            newErrors.year = "Debes ingresar un año.";
        } else if (
            formData.month === ""
        ) {
            newErrors.month = "Debe ingresar un mes.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrorField(newErrors);
            hasValidate = false;
        } else {
            setErrorField({});
        }
        return hasValidate;
    };

    const handleCreate = async () => {
        try {
            setDisableBtn(true);
            let hasValidate = validateData();
            if (!hasValidate) return;

            await handlecreateLatePaymentInterest();
            setDialogOpen(false);
            return;
        } catch (error) {
            console.log(error?.message);
        } finally {
            setDisableBtn(false);
        }
    };

    return (
        <>
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-50"
                    initialFocus={cancelButtonRef}
                    onClose={handleToggleDialog}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-tdark bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="text-tdark font-walsheim tracking-tight relative transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all my-8 max-w-sm p-6">
                                    <div>
                                        <div className="">
                                            <div className="flex justify-end w-full">
                                                <XMarkIcon
                                                    className="w-6 h-auto text-md flex justify-center border border-transparent rounded-full font-semibold text-tdark bg-purpleLight transition duration-300 focus:outline-none cursor-pointer"
                                                    onClick={handleToggleDialog}
                                                />
                                            </div>
                                            <div className="text-center mt-3 sm:mt-5">
                                                <Dialog.Title as="h1" className="text-xl font-semibold">
                                                    Agregar datos de interés Moratorio
                                                </Dialog.Title>
                                            </div>

                                            <div className="mt-2">
                                                <form action="">
                                                    <div className="mt-4">
                                                        <label htmlFor="accountNumber" className="block font-bold">
                                                            Interes usura TEA
                                                        </label>
                                                        <div>
                                                            <input
                                                                value={formData.interesUsuraTea}
                                                                onChange={handleChange}
                                                                type="text"
                                                                name="interesUsuraTea"
                                                                id="interesUsuraTea"
                                                                maxLength="40"
                                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0"
                                                            />
                                                        </div>
                                                        {errorField.interesUsuraTea && (
                                                            <span
                                                                className="text-sm"
                                                                style={{
                                                                    color: "#fc3e58",
                                                                    fontStyle: "italic",
                                                                    paddingTop: 0,
                                                                }}
                                                            >
                                                                {errorField.interesUsuraTea}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="mt-4">
                                                        <label htmlFor="year" className="block font-bold">
                                                            Año
                                                        </label>
                                                        <div>
                                                            <input
                                                                value={formData.year}
                                                                onChange={handleChange}
                                                                type="text"
                                                                name="year"
                                                                id="year"
                                                                maxLength="40"
                                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0"
                                                            />
                                                        </div>

                                                        {errorField.year && (
                                                            <span
                                                                className="text-sm"
                                                                style={{
                                                                    color: "#fc3e58",
                                                                    fontStyle: "italic",
                                                                    paddingBottom: 0,
                                                                }}
                                                            >
                                                                {errorField.year ?? ""}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="mt-4">
                                                        <label htmlFor="month" className="block font-bold">
                                                            Mes
                                                        </label>
                                                        <div>
                                                            <input
                                                                value={formData.month}
                                                                onChange={handleChange}
                                                                type="text"
                                                                name="month"
                                                                id="month"
                                                                maxLength="40"
                                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0"
                                                            />
                                                        </div>

                                                        {errorField.month && (
                                                            <span
                                                                className="text-sm"
                                                                style={{
                                                                    color: "#fc3e58",
                                                                    fontStyle: "italic",
                                                                    paddingBottom: 0,
                                                                }}
                                                            >
                                                                {errorField.month ?? ""}
                                                            </span>
                                                        )}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex mt-2 pt-6">
                                        <div className="flex gap-2 w-full">
                                            <div className="w-full">
                                                <button
                                                    disabled={disableBtn}
                                                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-md font-semibold text-white ${disableBtn ? "bg-grayP opacity-70" : "bg-purple hover:bg-purpleDark"} transition duration-300  focus:outline-none`}
                                                          onClick={handleCreate}
                                                >
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}
